
import { all, fork } from 'redux-saga/effects';

import * as authenticationSaga from '../auth/AuthenticationSaga';
import * as storageSaga from '../storage/StorageSaga';
import * as notetakerSaga from '../notetaker/NotetakerSaga'
import * as todosSaga from '../todos/TodosSaga'
import * as dbsSaga from '../dbs/dbsSaga'
import * as confirmationSaga from '../helper/confirmation-modal/confirmationSaga'
import * as scriptSaga from '../scripts/ScriptManagerSaga'
import * as rpcSaga from '../rpc/RPCSaga'
import * as timerSaga from '../timer/TimerSaga'
import * as notificacoesSaga from "../notificacoes/NotificacoesSaga"
import * as livrudoSaga from "../livrudo/LivrudoSaga"
import * as workSaga from "../work/WorkSaga"

export default function* rootSaga() {
    yield all([
        ...Object.values(authenticationSaga),
        ...Object.values(storageSaga),
        ...Object.values(notetakerSaga),
        ...Object.values(todosSaga),
        ...Object.values(dbsSaga),
        ...Object.values(confirmationSaga),
        ...Object.values(scriptSaga),
        ...Object.values(rpcSaga),
        ...Object.values(timerSaga),
        ...Object.values(notificacoesSaga),
        ...Object.values(livrudoSaga),
        ...Object.values(workSaga),
    ].map(fork))
}

